import React from "react";
import { Activity, Apple, Dumbbell, CheckCircle2 } from "lucide-react";

const services = [
  {
    icon: Activity,
    tag: "Body Composition Analysis",
    title: "Know what you're actually losing.",
    desc:
      "Clinical‑grade BIA scan measures body fat %, lean muscle mass, visceral fat, hydration and BMR. We track changes every 4 weeks so weight loss means fat loss — not muscle loss.",
    points: ["Body fat %", "Visceral fat score", "Lean muscle mass", "Metabolic age"],
    tint: "bg-[#EEF5EF] text-[#2E936F]",
  },
  {
    icon: Apple,
    tag: "Dietician Support",
    title: "Indian meals that work with your medication.",
    desc:
      "Our in‑house dietician builds a plan around your rotis, rice, curries and workplace canteen — protein‑forward, gut‑friendly, sustainable. Weekly check‑ins over WhatsApp, not generic PDFs.",
    points: ["Personalised Indian meal plan", "Shopping & restaurant guide", "Festival & travel tweaks", "Weekly WhatsApp follow‑up"],
    tint: "bg-[#FCE9E2] text-[#B84E38]",
  },
  {
    icon: Dumbbell,
    tag: "Physiotherapy",
    title: "Move without hurting your joints.",
    desc:
      "A certified physio designs a low‑impact strength and mobility routine — critical when you're carrying extra weight, have PCOS, or dealing with knee, back or shoulder pain from years of inactivity.",
    points: ["Posture & gait assessment", "Home‑friendly strength plan", "Knee & back pain protocols", "Progressive mobility drills"],
    tint: "bg-[#E8EEF5] text-[#1E4D8A]",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white border border-[#EAE7E1] px-3.5 py-1.5 font-micro text-[#2E936F]">
            Not just an injection
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
            A <em className="text-[#EB8771]">complete</em> weight‑loss programme.
          </h2>
          <p className="mt-5 text-[#38312C] leading-relaxed">
            Mounjaro works best when paired with nutrition, movement, and careful body‑composition
            tracking. Every patient gets all three — included in the programme, under one roof.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4">
          {services.map((s, i) => (
            <article
              key={s.tag}
              data-testid={`service-${i}`}
              className="group rounded-3xl bg-white border border-[#EAE7E1] p-8 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(36,34,32,0.15)] transition-all flex flex-col"
            >
              <div className={`h-12 w-12 rounded-2xl ${s.tint} grid place-items-center`}>
                <s.icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <span className="mt-6 font-micro text-[#6B6660]">{s.tag}</span>
              <p className="font-display text-2xl mt-2 text-[#242220] leading-snug">{s.title}</p>
              <p className="text-sm text-[#38312C] mt-3 leading-relaxed">{s.desc}</p>
              <ul className="mt-6 space-y-2 pt-5 border-t border-[#EAE7E1]">
                {s.points.map((p, j) => (
                  <li
                    key={j}
                    data-testid={`service-${i}-point-${j}`}
                    className="flex items-start gap-2.5 text-sm text-[#242220]"
                  >
                    <CheckCircle2 className="h-4 w-4 mt-0.5 text-[#779D7C]" strokeWidth={1.7} />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs text-[#6B6660] max-w-3xl">
          All three services are included — no extra bundling, no surprise add‑ons. We believe
          medication alone isn't the answer; what you eat and how you move makes the loss stick.
        </p>
      </div>
    </section>
  );
};
